module.exports = __webpack_public_path__ + "img/fatura.be0db5b3.svg";